<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title> Dados do registro </v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-12">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <v-text-field
                label="Usuario"
                v-model="current.username"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-4">
              <v-text-field
                label="Senha"
                v-model="current.password"
                :type="'password'"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-4">
              <v-select
                label="Status"
                v-model="current.enabled"
                :items="enabled"
                dense
                outlined
              ></v-select>
            </div>
            <div class="col-4">
              <v-banner>Permissões</v-banner>
              <v-checkbox v-for="item in permissions" :key="item.id"
                v-model="current.permissions"
                :label="item.value"
                :value="item.value"
              ></v-checkbox>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: function () {
    return {
      current: null,
      permissions: [],
      enabled: [
        { text: "Ativado", value: true },
        { text: "Desativado", value: false },
      ],
    };
  },
  created: function () {
    this.load();
    this.loadPermissions();
  },
  methods: {
      loadPermissions: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/permission", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.permissions = response.data;
        })
        .catch(function (error) {
          alert("Falha ao recuperar permissões!");
          console.log(error);
        });
    },
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/user/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
          me.current.password = "";
        })
        .catch(function (error) {
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    save: function () {
      var token = localStorage.getItem("token");
      if (this.current.id == 0) {
        api
          .post("/user", this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            alert("Cadastrado com sucesso!");
            router.push({ path: "/user" });
          })
          .catch(function (error) {
            alert("Falha ao criar registro!");
            console.log(error);
          });
      } else {
        api
          .put("/user/" + this.current.id, this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            alert("Atualizado com sucesso!");
            router.push({ path: "/user" });
          })
          .catch(function (error) {
            alert("Falha ao editar registro!");
            console.log(error);
          });
      }
    },
  },
};
</script>